/* GYMSPIDERR DISTRIBUTION - Brand interactions */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;
  var root = document.documentElement;
  var hasIO = 'IntersectionObserver' in window;
  var raf = window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : function (cb) { return setTimeout(function () { cb(performance.now()); }, 16); };

  function clamp(value, min, max) { return Math.min(max, Math.max(min, value)); }
  function wrap(value) { return value - Math.floor(value); }

  /* ---------------- Scroll reveal ---------------- */
  var revealObserver = null;

  function getObserver() {
    if (revealObserver || !hasIO) return revealObserver;
    revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.05 }
    );
    return revealObserver;
  }

  function observeReveals() {
    var observer = getObserver();

    document.querySelectorAll('[data-gsd-stagger]').forEach(function (group) {
      if (group.dataset.gsdStaggerDone) return;
      group.dataset.gsdStaggerDone = '1';
      Array.prototype.forEach.call(group.children, function (child, index) {
        child.style.setProperty('--gsd-i', String(Math.min(index, 8)));
      });
    });

    document.querySelectorAll('.gsd-reveal:not(.is-visible)').forEach(function (el) {
      if (observer) observer.observe(el);
      else el.classList.add('is-visible');
    });
  }

  // Respaldo: nada de la marca puede quedarse invisible si el observer falla.
  function revealFailsafe() {
    setTimeout(function () {
      document.querySelectorAll('.gsd-reveal:not(.is-visible)').forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) el.classList.add('is-visible');
      });
    }, 2500);
  }

  /* ---------------- Split de texto ---------------- */
  function wrapWords(el, className) {
    var words = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    words.forEach(function (word, index) {
      var mask = document.createElement('span');
      mask.className = className;
      mask.style.setProperty('--gsd-i', String(index));
      var inner = document.createElement('span');
      inner.textContent = word;
      mask.appendChild(inner);
      el.appendChild(mask);
      if (index < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
    return el.querySelectorAll('.' + className);
  }

  function splitText() {
    document.querySelectorAll('[data-gsd-split]:not([data-gsd-done])').forEach(function (el) {
      el.dataset.gsdDone = '1';
      wrapWords(el, 'gsd-split');
      el.classList.add('gsd-reveal');
    });
  }

  /* ---------------- Texto revelado con el scroll ---------------- */
  var scrubItems = [];

  function initScrub() {
    document.querySelectorAll('[data-gsd-scrub]:not([data-gsd-done])').forEach(function (el) {
      el.dataset.gsdDone = '1';
      var words = wrapWords(el, 'gsd-scrub-word');
      scrubItems.push({ el: el, words: words });
    });
  }

  function updateScrub() {
    scrubItems.forEach(function (item) {
      if (reduce) {
        item.words.forEach(function (word) { word.style.opacity = '1'; });
        return;
      }
      var rect = item.el.getBoundingClientRect();
      var start = window.innerHeight * 0.85;
      var end = window.innerHeight * 0.3;
      var progress = clamp((start - rect.top) / (start - end), 0, 1);
      var total = item.words.length;
      item.words.forEach(function (word, index) {
        var local = (progress - index / total) * total * 1.6;
        word.style.opacity = String(clamp(local, 0.1, 1));
      });
    });
  }

  /* ---------------- Parallax + estado de scroll ----------------
     Horizon 4 no hace scroll en la ventana: html/body quedan fijos y el
     contenido se desplaza dentro de .page-wrapper. Por eso se lee la
     posicion de ese contenedor y se escucha el scroll en fase de captura
     (los eventos scroll de elementos no burbujean hasta window). */
  function scrollTopNow() {
    var wrapper = document.querySelector('.page-wrapper');
    if (wrapper && wrapper.scrollHeight > wrapper.clientHeight + 1) return wrapper.scrollTop;
    return window.scrollY || window.pageYOffset || 0;
  }

  function initScrollEffects() {
    var ticking = false;

    function update() {
      ticking = false;
      var y = scrollTopNow();
      document.body.classList.toggle('gsd-scrolled', y > 24);

      if (!reduce) {
        document.querySelectorAll('[data-gsd-parallax]').forEach(function (el) {
          var speed = parseFloat(el.dataset.gsdParallax) || 0.12;
          var rect = el.getBoundingClientRect();
          var offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * speed;
          el.style.setProperty('--gsd-parallax-y', offset.toFixed(2) + 'px');
        });

        document.querySelectorAll('[data-gsd-spin]').forEach(function (el) {
          var speed = parseFloat(el.dataset.gsdSpin) || 0.04;
          el.style.setProperty('--gsd-spin', (y * speed).toFixed(2) + 'deg');
        });
      }

      updateScrub();
    }

    document.addEventListener('scroll', function (event) {
      // Ignora el scroll horizontal de los carruseles: solo importa el vertical.
      var target = event.target;
      if (target && target.nodeType === 1 && target !== document.documentElement && target !== document.body && !target.classList.contains('page-wrapper')) return;
      if (ticking) return;
      ticking = true;
      raf(update);
    }, { passive: true, capture: true });

    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* ---------------- Brillo que sigue al cursor ----------------
     Solo variables CSS de un degradado: la tarjeta no se mueve. */
  function initGlow() {
    if (!fine) return;
    document.querySelectorAll('[data-gsd-glow]:not([data-gsd-glow-done])').forEach(function (el) {
      el.dataset.gsdGlowDone = '1';
      el.addEventListener('pointermove', function (event) {
        var rect = el.getBoundingClientRect();
        el.style.setProperty('--gsd-glow-x', ((event.clientX - rect.left) / rect.width) * 100 + '%');
        el.style.setProperty('--gsd-glow-y', ((event.clientY - rect.top) / rect.height) * 100 + '%');
      });
    });
  }

  /* ---------------- La arana sigue al cursor ---------------- */
  var spiderTrackBound = false;

  function initSpiderTrack() {
    if (!fine || reduce || spiderTrackBound) return;
    if (!document.querySelector('[data-gsd-track]')) return;
    spiderTrackBound = true;

    window.addEventListener('pointermove', function (event) {
      document.querySelectorAll('[data-gsd-track]').forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (!rect.width) return;
        var dx = (event.clientX - (rect.left + rect.width / 2)) / window.innerWidth;
        var dy = (event.clientY - (rect.top + rect.height / 2)) / window.innerHeight;
        el.style.setProperty('--gsd-track-x', (dx * 26).toFixed(2) + 'px');
        el.style.setProperty('--gsd-track-y', (dy * 20).toFixed(2) + 'px');
        el.style.setProperty('--gsd-track-r', (dx * 7).toFixed(2) + 'deg');
      });
    }, { passive: true });
  }

  /* ---------------- Contadores ---------------- */
  function initCounters() {
    var nodes = document.querySelectorAll('[data-gsd-count]:not([data-gsd-count-done])');
    if (!nodes.length) return;

    function run(el) {
      if (el.dataset.gsdCountDone) return;
      el.dataset.gsdCountDone = '1';
      var target = parseFloat(el.dataset.gsdCount) || 0;
      if (reduce) { el.textContent = String(target); return; }
      var duration = 1600;
      var start = performance.now();
      (function step(now) {
        var progress = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = String(Math.round(target * eased));
        if (progress < 1) raf(step);
      })(start);
    }

    var observer = hasIO
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            run(entry.target);
          });
        }, { threshold: 0.4 })
      : null;

    nodes.forEach(function (el) {
      if (observer) observer.observe(el);
      setTimeout(function () { run(el); }, 2500);
    });
  }

  /* ---------------- Carruseles con flechas laterales ---------------- */
  function initCarousels() {
    document.querySelectorAll('[data-gsd-carousel]:not([data-gsd-car-done])').forEach(function (wrapEl) {
      wrapEl.dataset.gsdCarDone = '1';
      var track = wrapEl.querySelector('[data-gsd-carousel-track]');
      var prev = wrapEl.querySelector('[data-gsd-carousel-prev]');
      var next = wrapEl.querySelector('[data-gsd-carousel-next]');
      if (!track) return;

      function step() {
        var first = track.firstElementChild;
        if (!first) return 320;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 20;
        return first.getBoundingClientRect().width + gap;
      }

      function go(direction) {
        var max = track.scrollWidth - track.clientWidth;
        var target = track.scrollLeft + direction * step();
        // Al llegar a un extremo vuelve al otro: el carrusel nunca se "traba".
        if (direction > 0 && track.scrollLeft >= max - 4) target = 0;
        if (direction < 0 && track.scrollLeft <= 4) target = max;
        track.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });

      function sync() {
        var scrollable = track.scrollWidth - track.clientWidth > 4;
        if (prev) prev.hidden = !scrollable;
        if (next) next.hidden = !scrollable;
      }

      wrapEl.gsdScrollTo = function (index) {
        var item = track.children[index];
        if (!item) return;
        var left = item.offsetLeft - (track.clientWidth - item.offsetWidth) / 2;
        track.scrollTo({ left: Math.max(0, left), behavior: reduce ? 'auto' : 'smooth' });
      };

      wrapEl.gsdNearestIndex = function () {
        var center = track.scrollLeft + track.clientWidth / 2;
        var best = 0;
        var bestDist = Infinity;
        Array.prototype.forEach.call(track.children, function (item, index) {
          var dist = Math.abs(item.offsetLeft + item.offsetWidth / 2 - center);
          if (dist < bestDist) { bestDist = dist; best = index; }
        });
        return best;
      };

      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
  }

  /* ================================================================
     PillNav: relleno que sube por la pildora, texto que rueda y un
     punto activo que se desliza. Port del componente React a vanilla.
     ================================================================ */
  function initPillNav() {
    document.querySelectorAll('nav.menu-list').forEach(function (nav) {
      var titles = nav.querySelectorAll('.menu-list__list-item > .menu-list__link > .menu-list__link-title');
      titles.forEach(function (title) {
        if (title.dataset.gsdPill) return;
        title.dataset.gsdPill = '1';
        var text = title.textContent.trim();
        title.textContent = '';
        title.classList.add('gsd-pill');

        var fill = document.createElement('span');
        fill.className = 'gsd-pill__fill';
        fill.setAttribute('aria-hidden', 'true');
        var face = document.createElement('span');
        face.className = 'gsd-pill__face';
        face.textContent = text;
        var alt = document.createElement('span');
        alt.className = 'gsd-pill__alt';
        alt.setAttribute('aria-hidden', 'true');
        alt.textContent = text;

        title.appendChild(fill);
        title.appendChild(face);
        title.appendChild(alt);
      });

      function measure() {
        nav.querySelectorAll('.gsd-pill').forEach(function (pill) {
          var w = pill.offsetWidth;
          var h = pill.offsetHeight;
          if (!w) return;
          var reach = Math.ceil(2 * Math.sqrt(Math.pow(w / 2, 2) + h * h)) + 2;
          pill.style.setProperty('--pn-fill', reach + 'px');
        });
      }

      // Punto indicador dentro de cada link (sin tocar el posicionamiento del
      // nav: el submenu de Horizon se ubica respecto al header completo).
      nav.querySelectorAll('.menu-list__list-item > .menu-list__link').forEach(function (link) {
        if (link.querySelector('.gsd-pill-dot')) return;
        var dot = document.createElement('span');
        dot.className = 'gsd-pill-dot';
        dot.setAttribute('aria-hidden', 'true');
        link.appendChild(dot);
      });

      measure();
      if (nav.dataset.gsdPillNav) return;
      nav.dataset.gsdPillNav = '1';
      window.addEventListener('resize', measure, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    });
  }

  /* ================================================================
     SpecularButton (port vanilla). Un solo contexto WebGL2 compartido
     dibuja cada boton y se copia a un canvas 2D propio: asi no se
     supera el limite de contextos WebGL del navegador con muchas
     tarjetas en pantalla.
     ================================================================ */
  var Spec = (function () {
    var PAD = 24;
    var VERTEX = '#version 300 es\nin vec2 aPosition;\nvoid main() {\n  gl_Position = vec4(aPosition, 0.0, 1.0);\n}';
    var FRAGMENT = [
      '#version 300 es',
      'precision highp float;',
      'uniform vec2 uCenter;',
      'uniform vec2 uHalf;',
      'uniform float uRadius;',
      'uniform float uPx;',
      'uniform float uSpot;',
      'uniform vec2 uEntry;',
      'uniform vec3 uLineColor;',
      'uniform vec3 uBaseColor;',
      'uniform float uIntensity;',
      'uniform vec2 uWindow;',
      'uniform float uThickness;',
      'uniform float uGlow;',
      'out vec4 outColor;',
      'float roundedBox(vec2 p, vec2 b, float r) {',
      '  vec2 q = abs(p) - b + r;',
      '  return length(max(q, 0.0)) + min(max(q.x, q.y), 0.0) - r;',
      '}',
      'float loopPosition(vec2 p, vec2 b, float r) {',
      '  vec2 inner = b - r;',
      '  float arc = 1.5707963 * r;',
      '  float quarter = inner.x + inner.y + arc;',
      '  vec2 a = abs(p);',
      '  vec2 q = a - inner;',
      '  float s = q.x > 0.0 && q.y > 0.0',
      '    ? inner.y + atan(q.y, q.x) * r',
      '    : (q.x > q.y ? min(a.y, inner.y) : inner.y + arc + inner.x - min(a.x, inner.x));',
      '  if (p.x < 0.0) s = p.y >= 0.0 ? 2.0 * quarter - s : 2.0 * quarter + s;',
      '  else if (p.y < 0.0) s = 4.0 * quarter - s;',
      '  return s / max(4.0 * quarter, 0.0001);',
      '}',
      'float lobe(float position, float center) {',
      '  float gap = abs(fract(position - center + 0.5) - 0.5);',
      '  return 1.0 - smoothstep(uWindow.x, uWindow.x + uWindow.y, gap);',
      '}',
      'void main() {',
      '  vec2 p = gl_FragCoord.xy - uCenter;',
      '  float d = roundedBox(p, uHalf, uRadius);',
      '  float position = loopPosition(p, uHalf, uRadius);',
      '  float key = lobe(position, uSpot);',
      '  float back = lobe(position, uSpot + 0.5);',
      '  float streak = key + back * 0.45;',
      '  float width = max(uThickness * uPx * mix(1.0, max(key, back), 0.6), 0.35);',
      '  float band = smoothstep(-width - 0.6, -width + 0.6, d) * (1.0 - smoothstep(-0.6, 0.6, d));',
      '  float hair = smoothstep(-uPx - 0.6, -uPx + 0.6, d) * (1.0 - smoothstep(-0.6, 0.6, d));',
      '  float inside = 1.0 - smoothstep(-0.6, 0.6, d);',
      '  vec2 pool = (p - uEntry) / (uHalf.y * vec2(1.6, 1.1));',
      '  float glow = streak * 0.2 * exp(-abs(d + width * 0.5) / (5.0 * uPx)) + inside * 0.08 * exp(-dot(pool, pool));',
      '  float light = clamp((band * streak + glow * uGlow) * uIntensity, 0.0, 1.0);',
      '  vec4 base = vec4(uBaseColor, 1.0) * hair * 0.6;',
      '  outColor = vec4(uLineColor, 1.0) * light + base * (1.0 - light);',
      '}'
    ].join('\n');
    var UNIFORMS = ['uCenter', 'uHalf', 'uRadius', 'uPx', 'uSpot', 'uEntry', 'uLineColor', 'uBaseColor', 'uIntensity', 'uWindow', 'uThickness', 'uGlow'];

    // Paleta Gymspiderr Distribution: linea blanca sobre lila, filo lila claro.
    var DEFAULTS = {
      radius: 18,
      lineColor: [1, 1, 1],
      baseColor: [234 / 255, 214 / 255, 1],
      intensity: 1,
      idleIntensity: 0.35,
      shineSize: 10,
      shineFade: 34,
      thickness: 1.2,
      glow: 1,
      speed: 0.35,
      followMouse: true,
      autoAnimate: !reduce,
      proximity: 250
    };

    var gl = null;
    var glCanvas = null;
    var program = null;
    var uniforms = {};
    var vao = null;
    var tried = false;
    var buttons = [];
    var pointer = { x: 0, y: 0, known: false };
    var frameId = 0;
    var last = 0;
    var visibilityObserver = null;
    var resizeObserver = null;

    function compile(type, source) {
      var shader = gl.createShader(type);
      if (!shader) return null;
      gl.shaderSource(shader, source);
      gl.compileShader(shader);
      if (gl.getShaderParameter(shader, gl.COMPILE_STATUS)) return shader;
      gl.deleteShader(shader);
      return null;
    }

    function setup() {
      if (tried) return !!program;
      tried = true;
      try {
        glCanvas = document.createElement('canvas');
        gl = glCanvas.getContext('webgl2', {
          alpha: true,
          premultipliedAlpha: true,
          antialias: false,
          depth: false,
          stencil: false,
          preserveDrawingBuffer: true
        });
        if (!gl) return false;
        var vertex = compile(gl.VERTEX_SHADER, VERTEX);
        var fragment = compile(gl.FRAGMENT_SHADER, FRAGMENT);
        var linked = gl.createProgram();
        if (!vertex || !fragment || !linked) return false;
        gl.attachShader(linked, vertex);
        gl.attachShader(linked, fragment);
        gl.bindAttribLocation(linked, 0, 'aPosition');
        gl.linkProgram(linked);
        gl.deleteShader(vertex);
        gl.deleteShader(fragment);
        if (!gl.getProgramParameter(linked, gl.LINK_STATUS)) return false;
        program = linked;
        UNIFORMS.forEach(function (name) { uniforms[name] = gl.getUniformLocation(program, name); });
        var buffer = gl.createBuffer();
        vao = gl.createVertexArray();
        gl.bindVertexArray(vao);
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
        gl.enableVertexAttribArray(0);
        gl.vertexAttribPointer(0, 2, gl.FLOAT, false, 0, 0);
        gl.bindVertexArray(null);
        glCanvas.addEventListener('webglcontextlost', function (event) {
          event.preventDefault();
          program = null;
          buttons.forEach(function (b) { b.el.classList.remove('gsd-spec--gl'); });
        });
        return true;
      } catch (e) {
        program = null;
        return false;
      }
    }

    function loopPosition(x, y, halfX, halfY, r) {
      var innerX = halfX - r;
      var innerY = halfY - r;
      var arc = (Math.PI / 2) * r;
      var quarter = innerX + innerY + arc;
      var ax = Math.abs(x);
      var ay = Math.abs(y);
      var qx = ax - innerX;
      var qy = ay - innerY;
      var s;
      if (qx > 0 && qy > 0) s = innerY + Math.atan2(qy, qx) * r;
      else if (qx > qy) s = Math.min(ay, innerY);
      else s = innerY + arc + innerX - Math.min(ax, innerX);
      if (x < 0) s = y >= 0 ? 2 * quarter - s : 2 * quarter + s;
      else if (y < 0) s = 4 * quarter - s;
      return wrap(s / Math.max(4 * quarter, 0.0001));
    }

    function rimPoint(position, halfX, halfY, r) {
      var innerX = halfX - r;
      var innerY = halfY - r;
      var arc = (Math.PI / 2) * r;
      var quarter = innerX + innerY + arc;
      var s = wrap(position) * 4 * quarter;
      var signX = 1;
      var signY = 1;
      if (s > 3 * quarter) { s = 4 * quarter - s; signY = -1; }
      else if (s > 2 * quarter) { s -= 2 * quarter; signX = -1; signY = -1; }
      else if (s > quarter) { s = 2 * quarter - s; signX = -1; }
      var x = innerX - (s - innerY - arc);
      var y = halfY;
      if (s <= innerY) { x = halfX; y = s; }
      else if (s <= innerY + arc) {
        var angle = (s - innerY) / Math.max(r, 0.0001);
        x = innerX + Math.cos(angle) * r;
        y = innerY + Math.sin(angle) * r;
      }
      return [x * signX, y * signY];
    }

    function cornerRadius(b) { return Math.min(b.s.radius, b.view.width / 2, b.view.height / 2); }

    function restSpot(b) {
      var r = cornerRadius(b);
      var inset = r * (1 - Math.SQRT1_2);
      return loopPosition(inset - b.view.width / 2, b.view.height / 2 - inset, b.view.width / 2, b.view.height / 2, r);
    }

    function aim(b) {
      if (!b.s.followMouse || !pointer.known) return null;
      var rect = b.el.getBoundingClientRect();
      var scale = rect.width / b.view.width || 1;
      var halfX = b.view.width / 2;
      var halfY = b.view.height / 2;
      var x = (pointer.x - rect.left - rect.width / 2) / scale;
      var y = (rect.top + rect.height / 2 - pointer.y) / scale;
      var distance = Math.hypot(Math.max(Math.abs(x) - halfX, 0), Math.max(Math.abs(y) - halfY, 0));
      var t = clamp(1 - distance / b.s.proximity, 0, 1);
      var near = t * t * (3 - 2 * t);
      if (near <= 0) return null;
      var nearest = loopPosition(x, y, halfX, halfY, cornerRadius(b));
      if (distance > 0) return { spot: nearest, near: near };
      var depth = clamp(Math.min(halfX - Math.abs(x), halfY - Math.abs(y)) / (halfY * 0.8), 0, 1);
      var sway = restSpot(b) - (x / halfX) * 0.06 - (y / halfY) * 0.02;
      var offset = sway - nearest - Math.round(sway - nearest);
      return { spot: wrap(nearest + offset * depth * depth * (3 - 2 * depth)), near: near };
    }

    function draw(b) {
      if (!program) return;
      var width = b.view.width;
      var height = b.view.height;
      if (glCanvas.width !== b.canvas.width || glCanvas.height !== b.canvas.height) {
        glCanvas.width = b.canvas.width;
        glCanvas.height = b.canvas.height;
      }
      var scaleX = glCanvas.width / (width + PAD * 2);
      var scaleY = glCanvas.height / (height + PAD * 2);
      gl.viewport(0, 0, glCanvas.width, glCanvas.height);
      gl.clearColor(0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT);
      gl.useProgram(program);
      gl.uniform2f(uniforms.uCenter, (PAD + width / 2) * scaleX, (PAD + height / 2) * scaleY);
      gl.uniform2f(uniforms.uHalf, (width / 2) * scaleX, (height / 2) * scaleY);
      var r = cornerRadius(b);
      gl.uniform1f(uniforms.uRadius, r * scaleX);
      gl.uniform1f(uniforms.uPx, b.view.ratio);
      var rim = rimPoint(b.state.spot, width / 2, height / 2, r);
      var len = Math.max(Math.hypot(rim[0], rim[1]), 0.0001);
      var pull = 1 - Math.min(0.35 * (height / 2), len) / len;
      gl.uniform1f(uniforms.uSpot, b.state.spot);
      gl.uniform2f(uniforms.uEntry, rim[0] * pull * scaleX, rim[1] * pull * scaleY);
      gl.uniform3fv(uniforms.uLineColor, b.s.lineColor);
      gl.uniform3fv(uniforms.uBaseColor, b.s.baseColor);
      gl.uniform1f(uniforms.uIntensity, b.s.intensity * (b.state.level + b.state.press * 0.8));
      gl.uniform2f(uniforms.uWindow, b.s.shineSize / 360 + b.state.press * 0.06, b.s.shineFade / 360 + 0.0001);
      gl.uniform1f(uniforms.uThickness, b.s.thickness);
      gl.uniform1f(uniforms.uGlow, b.s.glow);
      gl.bindVertexArray(vao);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
      gl.bindVertexArray(null);
      b.ctx.clearRect(0, 0, b.canvas.width, b.canvas.height);
      b.ctx.drawImage(glCanvas, 0, 0);
    }

    function stepButton(b, dt) {
      if (!b.state.ready) {
        b.state.spot = restSpot(b);
        b.state.level = b.s.idleIntensity;
        b.state.ready = true;
        draw(b);
      }
      var target = aim(b);
      var spinning = b.s.autoAnimate && !target;
      var diff = 0;
      if (spinning) {
        // Sin el cursor cerca, el brillo blanco recorre el borde solo.
        b.state.spot = wrap(b.state.spot + (b.s.speed / (Math.PI * 2)) * dt);
      } else {
        diff = (target ? target.spot : restSpot(b)) - b.state.spot;
        diff -= Math.round(diff);
        b.state.spot = wrap(b.state.spot + diff * (1 - Math.exp(-dt * 8)));
      }
      var idle = b.s.autoAnimate ? Math.max(b.s.idleIntensity, 0.6) : b.s.idleIntensity;
      var level = idle + (1 - idle) * (target ? target.near : 0);
      var levelDiff = level - b.state.level;
      b.state.level += levelDiff * (1 - Math.exp(-dt * 7));
      b.state.press *= Math.exp(-dt * 5);
      var settling = spinning || Math.abs(diff) > 0.0002 || Math.abs(levelDiff) > 0.001 || b.state.press > 0.002;
      if (settling) draw(b);
      return settling;
    }

    function frame(now) {
      frameId = 0;
      var dt = last ? Math.min(0.05, (now - last) / 1000) : 1 / 60;
      last = now;
      var busy = false;
      buttons.forEach(function (b) {
        if (!b.visible || !b.el.isConnected) return;
        if (stepButton(b, dt)) busy = true;
      });
      if (busy) frameId = raf(frame);
      else last = 0;
    }

    function wake() {
      if (!frameId && program) frameId = raf(frame);
    }

    function measure(b) {
      b.view.width = Math.max(1, b.el.offsetWidth);
      b.view.height = Math.max(1, b.el.offsetHeight);
      b.view.ratio = Math.min(window.devicePixelRatio || 1, 2);
      b.canvas.width = Math.max(1, Math.round((b.view.width + PAD * 2) * b.view.ratio));
      b.canvas.height = Math.max(1, Math.round((b.view.height + PAD * 2) * b.view.ratio));
      if (b.state.ready) draw(b);
    }

    function bindGlobal() {
      window.addEventListener('pointermove', function (event) {
        pointer.x = event.clientX;
        pointer.y = event.clientY;
        pointer.known = true;
        wake();
      }, { passive: true });
      window.addEventListener('pointerup', function (event) {
        if (event.pointerType === 'mouse') return;
        pointer.known = false;
        wake();
      }, { passive: true });
      document.documentElement.addEventListener('pointerleave', function () {
        pointer.known = false;
        wake();
      });
      window.addEventListener('resize', function () {
        buttons.forEach(measure);
        wake();
      }, { passive: true });
      if (hasIO) {
        visibilityObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var b = entry.target.gsdSpec;
            if (b) b.visible = entry.isIntersecting;
          });
          wake();
        });
      }
      if ('ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(function (entries) {
          entries.forEach(function (entry) {
            var b = entry.target.gsdSpec;
            if (b) measure(b);
          });
          wake();
        });
      }
    }

    function init() {
      var nodes = document.querySelectorAll('.gsd-spec:not([data-gsd-spec-done])');
      if (!nodes.length) return;
      if (!setup()) {
        nodes.forEach(function (el) { el.dataset.gsdSpecDone = '1'; });
        return;
      }
      if (!buttons.length) bindGlobal();

      nodes.forEach(function (el) {
        el.dataset.gsdSpecDone = '1';
        var canvas = document.createElement('canvas');
        canvas.className = 'gsd-spec__light';
        canvas.setAttribute('aria-hidden', 'true');
        el.insertBefore(canvas, el.firstChild);
        var ctx = canvas.getContext('2d');
        if (!ctx) return;
        el.classList.add('gsd-spec--gl');

        var s = Object.assign({}, DEFAULTS);
        if (el.dataset.radius) s.radius = parseFloat(el.dataset.radius) || s.radius;

        var b = {
          el: el,
          canvas: canvas,
          ctx: ctx,
          s: s,
          view: { width: 1, height: 1, ratio: 1 },
          state: { spot: 0, level: 0, press: 0, ready: false },
          visible: !hasIO
        };
        el.gsdSpec = b;
        buttons.push(b);

        el.addEventListener('pointerdown', function (event) {
          pointer.x = event.clientX;
          pointer.y = event.clientY;
          pointer.known = true;
          b.state.press = 1;
          wake();
        });

        measure(b);
        stepButton(b, 1 / 60);
        if (visibilityObserver) visibilityObserver.observe(el);
        if (resizeObserver) resizeObserver.observe(el);
      });

      // Limpia botones que Horizon ya quito del DOM (filtros, paginacion).
      buttons = buttons.filter(function (b) {
        if (b.el.isConnected) return true;
        if (visibilityObserver) visibilityObserver.unobserve(b.el);
        if (resizeObserver) resizeObserver.unobserve(b.el);
        return false;
      });
      wake();
    }

    return { init: init };
  })();

  /* ================================================================
     OptionWheel (port vanilla): lista vertical curva con blur y fade.
     Rueda/trackpad, arrastre, teclado y clic. Opcionalmente sincroniza
     un carrusel (data-gsd-wheel-target).
     ================================================================ */
  function initWheels() {
    document.querySelectorAll('[data-gsd-wheel]:not([data-gsd-wheel-done])').forEach(function (rootEl) {
      rootEl.dataset.gsdWheelDone = '1';
      var items = Array.prototype.slice.call(rootEl.querySelectorAll('.gsd-wheel__item'));
      var count = items.length;
      if (!count) return;

      var cfg = {
        spacing: parseFloat(rootEl.dataset.spacing) || 1.4,
        curve: 1,
        tilt: parseFloat(rootEl.dataset.tilt) || 6,
        blur: reduce ? 0 : 2,
        fade: parseFloat(rootEl.dataset.fade) || 0.25,
        minOpacity: 0.05,
        smoothing: reduce ? 1 : 200
      };

      var selected = clamp(parseInt(rootEl.dataset.selected, 10) || 0, 0, count - 1);
      var pos = selected;
      var target = selected;
      var looping = false;
      var lastTime = 0;
      var wheelTimer = null;
      var drag = null;
      var dragMoved = false;
      var syncingFromCarousel = false;
      var direct = rootEl.hasAttribute('data-gsd-wheel-direct');
      var targetCarousel = rootEl.dataset.gsdWheelTarget ? document.getElementById(rootEl.dataset.gsdWheelTarget) : null;
      var cta = rootEl.dataset.gsdWheelCta ? document.getElementById(rootEl.dataset.gsdWheelCta) : null;

      function rowH() {
        var size = parseFloat(getComputedStyle(items[0]).fontSize) || 24;
        return Math.max(size * cfg.spacing, 1);
      }

      function layout(current) {
        var h = rowH();
        var tiltRad = (cfg.tilt * Math.PI) / 180;
        var R = tiltRad > 0.0005 ? h / tiltRad : 0;
        items.forEach(function (el, i) {
          var d = i - current;
          var dist = Math.abs(d);
          var x = 0;
          var y = d * h;
          var rot = 0;
          if (R > 0) {
            var ang = Math.max(-Math.PI / 2, Math.min(Math.PI / 2, d * tiltRad));
            y = R * Math.sin(ang);
            x = -R * (1 - Math.cos(ang)) * cfg.curve;
            rot = (ang * 180) / Math.PI;
          }
          el.style.transform = 'translate(' + x.toFixed(2) + 'px, calc(' + y.toFixed(2) + 'px - 50%)) rotate(' + rot.toFixed(3) + 'deg)';
          el.style.opacity = String(Math.max(cfg.minOpacity, 1 - dist * cfg.fade));
          el.style.filter = cfg.blur > 0 ? 'blur(' + (dist * cfg.blur).toFixed(2) + 'px)' : 'none';
          el.style.setProperty('--ow-p', Math.max(0, 1 - Math.min(dist, 1)).toFixed(4));
        });
      }

      function frame(now) {
        var dt = Math.min((now - lastTime) / 1000, 0.05);
        lastTime = now;
        var k = 1 - Math.exp(-dt / (Math.max(cfg.smoothing, 1) / 1000));
        var next = pos + (target - pos) * k;
        var settled = Math.abs(target - next) < 0.001;
        if (settled) next = target;
        pos = next;
        layout(pos);
        if (settled) looping = false;
        else raf(frame);
      }

      function startLoop() {
        if (looping) return;
        looping = true;
        lastTime = performance.now();
        raf(frame);
      }

      function setSelected(index) {
        if (index === selected) return;
        selected = index;
        items.forEach(function (el, i) {
          var on = i === index;
          el.classList.toggle('gsd-wheel__item--selected', on);
          el.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        rootEl.dataset.selected = String(index);
        if (cta && items[index].href) cta.href = items[index].href;
        if (targetCarousel) {
          Array.prototype.forEach.call(targetCarousel.querySelectorAll('[data-gsd-carousel-track] > *'), function (card, i) {
            card.classList.toggle('is-active', i === index);
          });
          if (!syncingFromCarousel && targetCarousel.gsdScrollTo) targetCarousel.gsdScrollTo(index);
        }
        rootEl.dispatchEvent(new CustomEvent('gsd:wheel-change', { bubbles: true, detail: { index: index } }));
      }

      function applyTarget(value, snap) {
        var v = clamp(value, 0, count - 1);
        if (snap) v = Math.round(v);
        target = v;
        setSelected(Math.round(v));
        startLoop();
      }

      rootEl.addEventListener('wheel', function (event) {
        var delta = event.deltaMode === 1 ? event.deltaY * 24 : event.deltaY;
        // En los extremos dejamos que la pagina siga bajando/subiendo.
        if ((delta > 0 && target >= count - 1) || (delta < 0 && target <= 0)) return;
        event.preventDefault();
        var stepSize = Math.max(-1, Math.min(1, delta / rowH()));
        applyTarget(target + stepSize, false);
        if (wheelTimer) clearTimeout(wheelTimer);
        wheelTimer = setTimeout(function () { applyTarget(target, true); }, 140);
      }, { passive: false });

      rootEl.addEventListener('pointerdown', function (event) {
        drag = { y: event.clientY, start: target, id: event.pointerId };
        dragMoved = false;
      });

      rootEl.addEventListener('pointermove', function (event) {
        if (!drag) return;
        var dy = event.clientY - drag.y;
        if (!dragMoved && Math.abs(dy) > 4) {
          dragMoved = true;
          rootEl.classList.add('gsd-wheel--dragging');
          try { rootEl.setPointerCapture(drag.id); } catch (e) {}
        }
        if (dragMoved) applyTarget(drag.start - dy / rowH(), false);
      });

      function endDrag() {
        if (!drag) return;
        drag = null;
        rootEl.classList.remove('gsd-wheel--dragging');
        if (dragMoved) applyTarget(target, true);
      }

      rootEl.addEventListener('pointerup', endDrag);
      rootEl.addEventListener('pointercancel', endDrag);

      items.forEach(function (el, index) {
        el.addEventListener('click', function (event) {
          if (dragMoved) {
            event.preventDefault();
            dragMoved = false;
            return;
          }
          // Con data-gsd-wheel-direct el toque navega siempre; si no, el
          // primer clic centra la opcion y el segundo navega.
          if (index !== selected && !direct) {
            event.preventDefault();
            applyTarget(index, true);
          }
        });
      });

      rootEl.addEventListener('keydown', function (event) {
        var delta = null;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') delta = -1;
        else if (event.key === 'ArrowDown' || event.key === 'ArrowRight') delta = 1;
        else if (event.key === 'Enter' && items[selected].href) {
          window.location.href = items[selected].href;
          return;
        }
        if (delta == null) return;
        event.preventDefault();
        applyTarget(Math.round(target) + delta, true);
      });

      if (targetCarousel) {
        var track = targetCarousel.querySelector('[data-gsd-carousel-track]');
        var scrollTimer = null;
        if (track) {
          track.addEventListener('scroll', function () {
            if (scrollTimer) clearTimeout(scrollTimer);
            scrollTimer = setTimeout(function () {
              if (!targetCarousel.gsdNearestIndex) return;
              syncingFromCarousel = true;
              applyTarget(targetCarousel.gsdNearestIndex(), true);
              syncingFromCarousel = false;
            }, 160);
          }, { passive: true });
        }
      }

      items.forEach(function (el, i) {
        el.classList.toggle('gsd-wheel__item--selected', i === selected);
        el.setAttribute('aria-selected', i === selected ? 'true' : 'false');
      });
      if (cta && items[selected].href) cta.href = items[selected].href;
      if (targetCarousel) {
        var first = targetCarousel.querySelector('[data-gsd-carousel-track] > *');
        if (first) first.classList.add('is-active');
      }
      layout(pos);
      window.addEventListener('resize', function () { layout(pos); }, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { layout(pos); });
    });
  }

  /* ---------------- Boton flotante de WhatsApp ---------------- */
  // Chat directo con +56 9 8426 7307. (El link de catalogo usa el mismo
  // numero: https://wa.me/c/56984267307; el id 74569272582203 da 404.)
  var WHATSAPP_URL = 'https://wa.me/56984267307';

  function initWhatsApp() {
    if (document.getElementById('gsd-wa')) return;
    var link = document.createElement('a');
    link.id = 'gsd-wa';
    link.className = 'gsd-wa';
    link.href = WHATSAPP_URL;
    link.target = '_blank';
    link.rel = 'noopener';
    link.setAttribute('aria-label', 'Escríbenos por WhatsApp al +56 9 8426 7307');
    link.innerHTML =
      '<span class="gsd-wa__tip">¿Dudas? Escríbenos</span>' +
      '<svg viewBox="0 0 32 32" fill="currentColor" aria-hidden="true"><path d="M16.04 3C8.86 3 3.02 8.82 3.02 15.98c0 2.29.6 4.52 1.74 6.49L3 29l6.7-1.75a13 13 0 0 0 6.33 1.62h.01c7.18 0 13.02-5.82 13.02-12.98C29.06 8.82 23.22 3 16.04 3Zm0 23.68h-.01a10.8 10.8 0 0 1-5.5-1.5l-.4-.24-3.98 1.04 1.06-3.87-.26-.4a10.7 10.7 0 0 1-1.65-5.73c0-5.95 4.85-10.8 10.82-10.8 5.96 0 10.81 4.85 10.81 10.8 0 5.96-4.85 10.7-10.89 10.7Zm5.93-8.08c-.32-.16-1.93-.95-2.23-1.06-.3-.11-.52-.16-.74.16-.22.32-.85 1.06-1.04 1.28-.19.22-.38.24-.71.08-.32-.16-1.37-.5-2.6-1.6-.96-.85-1.61-1.9-1.8-2.22-.19-.32-.02-.5.14-.66.15-.15.32-.38.49-.57.16-.19.22-.32.32-.54.11-.22.05-.4-.03-.57-.08-.16-.74-1.77-1.01-2.43-.27-.64-.54-.55-.74-.56h-.63c-.22 0-.57.08-.87.4-.3.32-1.14 1.11-1.14 2.71 0 1.6 1.17 3.14 1.33 3.36.16.22 2.3 3.5 5.56 4.9.78.34 1.39.54 1.86.69.78.25 1.49.21 2.05.13.63-.09 1.93-.79 2.2-1.55.27-.76.27-1.42.19-1.55-.08-.13-.3-.21-.62-.37Z"/></svg>';
    document.body.appendChild(link);
  }

  /* ---------------- Arranque ---------------- */
  function safe(fn) {
    try { fn(); } catch (e) { if (window.console) console.warn('[gsd]', e); }
  }

  function refresh() {
    safe(splitText);
    safe(initScrub);
    safe(observeReveals);
    safe(initGlow);
    safe(initSpiderTrack);
    safe(initCounters);
    safe(initCarousels);
    safe(initWheels);
    safe(initPillNav);
    safe(Spec.init);
  }

  function boot() {
    safe(initWhatsApp);
    refresh();
    safe(initScrollEffects);
    revealFailsafe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  ['shopify:section:load', 'shopify:section:select', 'pageshow'].forEach(function (name) {
    document.addEventListener(name, refresh);
  });

  // Horizon re-renderiza grillas (filtros, paginacion, carrito): volvemos a
  // enganchar solo lo nuevo. Solo cambios de hijos, con espera de 250 ms.
  var pending = null;
  var mo = new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      refresh();
    }, 250);
  });

  mo.observe(document.body || root, { childList: true, subtree: true });
})();
